// extracted by mini-css-extract-plugin
export default {"wrapper":"login_wrapper__BD-Pf","buttons":"login_buttons__GX6he"};